// import type { Configuration } from '@repo/api-gw-sdk';
import {
  ConnectAzureBackupApplicationsApi,
  type Configuration,
} from '@repo/api-gw-sdk';
import type { SWRConfiguration } from 'swr';

import type { HttpClient } from './httpClient';

const baseUrl = '/onboarding';

let numOfStatusSamples = 0;

// export const onboarding = (
//   httpClient: HttpClient,
//   config: Configuration,
//   currentProjectId: string
// ) => {
export const onboarding = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const connectAppApi = new ConnectAzureBackupApplicationsApi(config);

  return {
    appModule: {
      deploy: async (data: {
        eonBackupApplicationName: string;
        eonBackupApplicationServicePrincipalId: string;
        customerBackupAppId: string;
        customerBackupAppServicePrincipalId: string;
      }) => {
        try {
          const response = await connectAppApi.connectAzureBackupApplications(
            currentProjectId,
            {
              eonBackupServicePrincipalId:
                data.eonBackupApplicationServicePrincipalId,
              customerBackupApplicationId: data.customerBackupAppId,
              customerBackupServicePrincipalId:
                data.customerBackupAppServicePrincipalId,
            }
          );
          return response;
        } catch (error) {
          console.error('Error calling connectAzureBackupApplications:', error);
          throw error;
        }
      },
    },
    backupAccount: {
      deploy: (data: {
        backupSubscriptionId: string;
        regionName: string;
        adxClusterId: string;
        adxClusterIdentity: string;
        adxClusterUri: string;
      }) => {
        return setTimeout(() => void Promise.resolve(data), 1000);
      },
      getDeployStatus: (swrOptions?: SWRConfiguration) => {
        return httpClient.execute(
          [baseUrl, '/backup-account/deploy-status'],
          async () => {
            return numOfStatusSamples++ > 3
              ? {
                  status: 'deployed',
                }
              : {
                  status: 'inProgress',
                };
          },
          swrOptions
        );
      },
    },
    vaultAccount: {
      deploy: (data: { vaultSubscriptionId: string }) => {
        return setTimeout(() => void Promise.resolve(data), 1000);
      },
    },
    sourceAccount: {
      deploy: (data: {
        sourceSubscriptionId: string;
        sourceManagementGroupId: string;
      }) => {
        return setTimeout(() => void Promise.resolve(data), 1000);
      },
    },
  };
};
